// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import _Button from "../Buttons/FlatButton";

import _Money from "../Money";
import { Link as _Link } from "../common/Link";
import { fontSize } from "../common/styled-mixins";
import SimpleSpinner from "../Spinners/SimpleSpinner";

import { StyledDateIcon as DateIcon } from "../Icons/Date";

export const News = styled.div`
  padding: 17px;
  background-color: #fff;
  border-radius: 2px 2px 0 0;

  @media (max-width: 365px) {
    padding: 17px 10px;
    border-radius: 0;
  }

  :not(:first-child) {
    border-top: 1px solid #ccc;
  }
`;

export const TitleLink = styled(_Link)`
  font-weight: bold;
  font-size: ${fontSize(14)};
  line-height: 1.2;
  color: #252525;//${({ theme }) => theme.indexMajor};
  text-decoration: none;

  :hover,
  :focus,
  :active {
    color: ${({ theme }) => theme.mainLink};
    text-decoration: underline;
  }
`;

const TimestampView = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  font-size: ${fontSize(12)};
  color: #99959d;//${({ theme }) => theme.textMuted};
`;

export const Link = styled(_Link)`
  color: ${({ theme }) => theme.mainLink};
  text-decoration: underline;

  :hover,
  :focus,
  :active {
    text-decoration: none;
  }
`;

export const Money = styled(_Money)`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.upper};
`;

export const Button = styled(_Button)`
  min-width: 0px;
  width: 100%;
  padding: 7px 10px;
  line-height: 1.25;
`;

export const Subscribe = styled.span`
  text-transform: lowercase;

  ${({ theme }) =>
    theme.lang !== "ar" &&
    css`
      ::first-letter {
        text-transform: uppercase;
      }
    `};
`;

const SpinnerWrapper = styled.span`
  width: 1em;
  height: 1em;
  line-height: 1;
`;

export const Spinner = () => (
  <SpinnerWrapper>
    <SimpleSpinner />
  </SpinnerWrapper>
);

export const Timestamp = ({ children }: { children: React.Node }) => (
  <TimestampView>
    <DateIcon />
    {children}
  </TimestampView>
);



// WEBPACK FOOTER //
// ./src/components/Bell/Item.js